import { Box, Flex } from '@chakra-ui/react';
import i18next from 'i18next';
import { NavLink } from 'react-router-dom';

import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';

import { COMMON_WEB_PATH } from '../../constant';

const hotType = [
  // {
  //   type: 'EXCU',
  //   label: '獨家',
  //   hash: 'exclusiveBrandGames',
  //   text: 'ExclusiveGame',
  //   imgClassName: {
  //     w: '75%',
  //     h: '145px'
  //   },
  //   activeImgClass: {
  //     transform: 'scaleX(1.1) scaleY(1.5)'
  //   }
  // },
  {
    type: 'HOT',
    label: '熱門',
    hash: 'Popular',
    imgClassName: {
      w: '86%',
      h: '135px'
    },
    activeImgClass: {
      transform: 'scaleX(1.1) scaleY(1.6)'
    }
  },
  {
    type: 'NEW',
    label: '最新',
    hash: 'New',
    className: {
      mt: '15px'
    },
    imgClassName: {
      w: '90%',
      h: '155px'
    },
    activeImgClass: {
      transform: 'scaleX(1.2) scaleY(1.4)'
    }
  }
];

const MenuMachine = () => {
  const isLandscapeMachine = useIsLandScapeMachine();
  if (isLandscapeMachine) return null;
  return (
    <Box
      maxW={`375px`}
      display={{
        base: 'none',
        md: 'block'
      }}
      w={{
        base: '0px',
        md: '100%'
      }}
      overflow="visible"
      bgSize="cover"
      bgPos="center"
      bgRepeat={`no-repeat`}
      maxH="400px"
      zIndex={1000}
      pt={{
        base: '0px',
        sm: '0px'
      }}
    >
      <Box h={`100%`} position="relative" left="0px" pb={{ base: '0px' }}>
        <Flex
          w={{
            base: '285px',
            md: '100%',
            lg: '100%'
          }}
          // h={'calc(100% - 0px)'}
          bg="transparent"
          direction={`column`}
          alignItems={`flex-end`}
          gap={{
            base: '10px',
            lg: '25px'
          }}
          pb="20px"
          // mt="20px"
          onClick={(event) => {
            event.stopPropagation();
          }}
          className="no-scrollbar"
          bgPos="center"
        >
          <Flex w="100%" mt="3em" direction={`column`} gap="0px">
            {hotType.map((item) => {
              return (
                <Flex
                  role="group"
                  as={NavLink}
                  to={{
                    search: `?type=${item.hash}`
                  }}
                  cursor={'pointer'}
                  justifyContent={'center'}
                  align={'center'}
                  gap="5px"
                  w="100%"
                  position="relative"
                  direction={'column'}
                  {...item.className}
                >
                  <Box
                    {...item.imgClassName}
                    bgImage={`url("${COMMON_WEB_PATH}/blue-layout/header${i18next.language === 'tw' ? '' : `/${i18next.language}`}/${item.type}_menu.png")`}
                    bgSize="100%100%"
                    bgPos="center"
                    bgRepeat="no-repeat"
                    _groupHover={{
                      bgImage: `url("${COMMON_WEB_PATH}/blue-layout/header${i18next.language === 'tw' ? '' : `/${i18next.language}`}/${item.type}_menu_active.png")`,
                      ...item.activeImgClass
                    }}
                  />
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default MenuMachine;
